var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTimerDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11H17.5V20H15.5V11ZM13.5 2H19.5V4H13.5V2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5004 8.99914L27.0804 7.58914L24.8304 9.83914C22.9886 7.71217 20.3982 6.37657 17.5973 6.10984C14.7964 5.84312 12.0004 6.66577 9.79022 8.40688C7.58007 10.148 6.1257 12.6737 5.72929 15.4592C5.33287 18.2447 6.02489 21.0759 7.66156 23.3644C9.29823 25.653 11.7537 27.223 14.5178 27.7482C17.2819 28.2735 20.1422 27.7136 22.5042 26.1849C24.8662 24.6562 26.5485 22.2762 27.2015 19.5395C27.8544 16.8027 27.4279 13.9196 26.0104 11.4891L28.5004 8.99914ZM16.5004 25.9991C14.7204 25.9991 12.9803 25.4713 11.5003 24.4824C10.0203 23.4934 8.8667 22.0878 8.18551 20.4433C7.50432 18.7988 7.32609 16.9892 7.67336 15.2433C8.02063 13.4975 8.87779 11.8938 10.1365 10.6352C11.3951 9.3765 12.9988 8.51934 14.7446 8.17207C16.4904 7.8248 18.3 8.00303 19.9446 8.68422C21.5891 9.36541 22.9947 10.519 23.9837 11.999C24.9726 13.479 25.5004 15.2191 25.5004 16.9991C25.5004 19.3861 24.5522 21.6753 22.8644 23.3631C21.1766 25.0509 18.8874 25.9991 16.5004 25.9991Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTimerDark);
export default __webpack_public_path__ + "static/media/ic-timer-dark.c7284205d071d02f9a82e57ff6ffe9da.svg";
export { ForwardRef as ReactComponent };